<template>
    <main>
        <div class="container-fluid">
             <div class="mainButton">
                <div class="row">
                    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-end">
                        <DownloadAction v-if="downloadAction" ref="loaddownload"></DownloadAction>
                    </div>
                </div>
             </div>
             <div class="page-toolbar">
                <div class="page-title">
                    <span class="title">Detail Branch</span> 
                    <span class="star"> <i class="fa-solid fa-star"></i></span>
                </div>
            </div>
        </div>

      
        <GenericDetail v-if="generic" ref="loadGeneric"> </GenericDetail>
        <CustomDetail v-else=""></CustomDetail>
       
        <GenericMoreButton v-if="genericBtn" ref="loadgenericbtn"></GenericMoreButton>
        <CustomMoreButton v-else></CustomMoreButton>

    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/MultiBranchs/MenuList.vue";
    import lang from "@/views/modules/MultiBranchs/language/en";
    import GenericDetail from "@/components/layout/shared/generic/DetailView.vue";
    import GenericMoreButton from "@/components/layout/shared/generic/common/MoreButton.vue";
    import CustomMoreButton from "@/views/modules/MultiBranchs/MoreButton.vue";
    import CustomDetail from "@/views/modules/MultiBranchs/DetailView.vue";
    import DownloadAction from "@/components/layout/shared/generic/download/Download.vue";

    export default {
        name: "new-branch",
        components: {
            breadcrumbs,
            GenericDetail,
            CustomMoreButton,
            CustomDetail,
            GenericMoreButton,
            DownloadAction
        },
        data() {
            return {
                generic: false,
                genericBtn:true,
                lang: [],
                metaList: [],
                moreBtn: [
                    {
                        id: 'edit',
                        path: 'multibranchs',
                        label: lang.LBL_EDIT,
                        action:'edit',
                    },
                    {
                        id: 'delete',
                        path: 'multibranchs',
                        label: lang.LBL_DELETE,
                        action:'delete',
                    },
                    
                ],
                routePath: {
                    path: 'multibranchs',
                    detail: false
                },
                 
                downloadAction:false,
                dowlloadList:[
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        action:"",
                        module:"",
                    },
                    {
                        label: lang.LBL_DOWNLOAD_TWO,
                        action:"",
                        module:"",
                    }
                ]
            }
        },
        mounted() {
            this.childMethod();
            this.lang = lang;
            this.showdowmload();
        },
        methods: {
            childMethod() {
                if(this.generic == true){
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
                if(this.genericBtn == true){
                    this.$refs.loadgenericbtn.loadGenericBtn(this.moreBtn);
                }
               
               
            },
            showdowmload(){
                const self = this;
                
                if(self.downloadAction == true){
                    this.$refs.loaddownload.loadDownloadView(self.dowlloadList);
                }
                
            }
        }
    }

</script>
